interface NeoErrorProps {
  message?: string;
}

export const NeoError: React.FC<NeoErrorProps> = ({message}) => {
  return <h6 className="py-3 text-tiny text-danger">{message}</h6>;
};
